<template>
  <div id="noticias">
    <vue-headful :title="$store.state.option['news_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container">
      <div class="row p-t-40">
        <div :class="{'col-md-12 row p-v-30': 1, 'b-cinzento': index % 2 }" v-for="(dt, index) in noticias" :key="index">
          <div class="col-xs-12 col-sm-6 col-md-8 col-lg-7">
            <h3 class="laranja"><router-link :to="'/new/' + dt.slug">{{dt.title}}</router-link></h3>
            <p v-html="decodeHTMLEntities(dt.content.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 300) + '...')"></p>
            <!-- <p v-html="dt.content.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 300) + '...'"></p> -->
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-5">
            <router-link :to="'/new/' + dt.slug"><img :src="dt.capa ? '/images/' + dt.capa : '/img/img.png'" class="card-img-top" :alt="dt.title"></router-link>
          </div>
        </div>
        <!--<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" v-for="(dt, index) in noticias" :key="index">
          <div @click="$router.push('/new/' + dt.slug, () => {})" class="card mao float-left borda p-0 m-0 full-width">
            <div style="height:190px; line-height:190px;text-align:center;">
              <img :src="dt.capa ? '/images/' + dt.capa : '/img/img.png'" class="card-img-top" :alt="dt.title">
            </div>
            <div class="card-body text-center" style="height:140px;">
              <h5 class="card-title">{{dt.title}}</h5>
              <p class="card-text text-left" v-html="dt.content.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 50) + '...'"></p>
            </div>
          </div>
        </div>-->
      </div>
    </div>

    <div class="container text-right" v-if="last_page > 1">
      <nav class="float-right">
        <ul class="pagination">
          <li class="page-item" v-if="pag > 1">
            <router-link class="page-link" to="1" @click="searchFN(1)" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </router-link>
          </li>
          <li v-if="pag - 2 > 1" class="page-item"><router-link class="page-link" :to="pag - 2" @click="searchFN(pag - 2)">{{pag - 2}}</router-link></li>
          <li v-if="pag - 1 > 1" class="page-item"><router-link class="page-link" :to="pag - 1" @click="searchFN(pag - 1)">{{pag - 1}}</router-link></li>
          <li class="page-item active"><a class="page-link">{{pag}}</a></li>
          <li v-if="parseInt(pag) + 1 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 1" @click="searchFN(parseInt(pag) + 1)">{{parseInt(pag) + 1}}</router-link></li>
          <li v-if="parseInt(pag) + 2 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 2" @click="searchFN(parseInt(pag) + 2)">{{parseInt(pag) + 2}}</router-link></li>
          <li v-if="parseInt(pag) + 3 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 3" @click="searchFN(parseInt(pag) + 3)">{{parseInt(pag) + 2}}</router-link></li>
          <li class="page-item" v-if="pag < last_page">
            <router-link class="page-link" :to="last_page" @click="searchFN(last_page)" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="clearfix" style="margin-bottom: 40px;"></div>

    <pesquisa></pesquisa>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'
import pesquisa from '@/components/pesquisa'

export default {
  components: { titulo, pesquisa },
  data () {
    return {
      noticias: [],
      lang: '',
      pag: 1,
      last_page: 1
    }
  },
  watch: {
    '$route' (b, c) {
      this.SET_LOAD(true)
      this.init()
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.pag = this.$route.params.id
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['news_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['news_subtitle-' + this.lang])
        this.searchFN(this.pag)
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    searchFN (pag) {
      this.SET_LOAD1(true)
      this.axios.get('/pages?type=news&language=' + this.lang + '&page=' + (pag || 1)).then((res) => {
        this.pag = res.data.current_page
        this.last_page = res.data.last_page
        this.noticias = res.data.data
        this.SET_LOAD1()
      }, (er) => {
        this.$router.replace('/', () => {})
      })
    },
    decodeHTMLEntities (text) {
      let entities = {
        'amp': '&',
        'apos': '\'',
        '#x27': '\'',
        '#x2F': '/',
        '#39': '\'',
        '#47': '/',
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'quot': '"'
      }
      if (text) {
        return text.replace(/&([^;]+);/gm, (match, entity) => {
          return entities[entity] || match
        })
      }
      return ''
    }
  }
}
</script>
